import { Controller } from "@hotwired/stimulus"
import { renderSearchResults } from "../search_results"

export default class extends Controller {
  async load(event) {
    const link = event.target.closest("a[data-search-page]")
    if (!link || !this.element.contains(link) || link.textContent === "Previous") return
    event.preventDefault()
    if (this.abort) return
    const abort = new AbortController()
    this.abort = abort
    this.element.setAttribute("aria-busy", "true")
    const label = link.textContent
    link.textContent = "Loading…"
    try {
      const url = new URL(link.href, window.location.origin)
      url.searchParams.set("results_only", "1")
      const response = await fetch(url.href, {credentials: "same-origin", signal: abort.signal, headers: {Accept: "text/html"}})
      if (!response.ok) throw new Error("results_unavailable")
      const html = await response.text()
      if (!abort.signal.aborted) renderSearchResults(this.element, html, true)
    } catch (error) {
      if (!abort.signal.aborted) link.textContent = `${label} — try again`
    } finally {
      if (this.abort === abort) {
        this.abort = null
        this.element.setAttribute("aria-busy", "false")
      }
    }
  }

  disconnect() {
    this.abort?.abort()
    this.abort = null
  }
}
